import { styled } from "webapp/styled-components";

export const TimerStyle = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 20px auto 10px;
    .timer-container {
        display: grid;
        width: 290px;
        height: 290px;
        justify-items: center;
        align-items: center;
        > * {
            grid-area: 1 / 1;
        }
        svg {
            transform: scale(1.7);
            position: relative;
        }
        svg line {
            stroke: ${p => p.theme.primaryAccentColor};
            stroke-width: 2;
        }

        .timer-text {
            ${p => p.theme.fontStyles.AccentHeader1}
        }
        .timer-text-container {
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
`;

export const ButtonRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;

    button {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        height: 40px;
        width: 40px;
        margin: 0 10px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
        border-radius: 50px;
        background-color: #5e5e5e;
        transform: scale(1);
        transition: 150ms ease-in-out transform box-shadow;

        :hover {
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.25);
        }

        :active {
            transform: scale(0.97);
            box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.15);
        }

        :disabled {
            opacity: 0.4;
        }
    }
`;
